<template>
  <div class="content">
    <div class="md-layout">

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card class="md-card-plain">
          <md-card-header>
            <h4 class="title"><b>Salesidol</b></h4>
            <p>List of customers</p>
          </md-card-header>
          <md-card-content>
            <template>
              <div>
                <md-table v-model="companies" :table-header-color="tableHeaderColor" md-fixed-header md-sort="name" md-sort-order="asc">
                  <md-table-row slot="md-table-row" slot-scope="{ item, index }">
                    <md-table-cell md-label="ID">{{ index+1 }}</md-table-cell>
                    <md-table-cell md-sort-by="name" md-label="Name">{{ item.name }}</md-table-cell>
                    <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
                    <md-table-cell md-sort-by="status" md-label="Status">{{ item.status }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </template>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
// import { SimpleTable} from "@/components";
import ApiService from '@/services/ApiService';

export default {
  // components: {
  //   SimpleTable
  // },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      companies: []
    };
  },
  mounted() {
    this.fetchCustomer();
  },
  methods: {
    async fetchCustomer(){
      var responce = await ApiService.fetchSalesidolCustomers();
      // console.log(responce);
      if(responce.data){
        this.companies = responce.data.customers;
        // console.log(this.companies);
      }
    }
  },
};
</script>
